import { 
  statusPaymentStart,
  statusPaymentSuccess,
  statusPaymentFailure 
} from "./paymentSlice";

import { get, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const showPaymentsApi = (doctor: string = "", ) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentStart())
    const response = await get(`payment?doctor=${doctor}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusPaymentFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentFailure(errData))
      return [errData]
    }
  }
}

export const AddPaymentApi = (data: any, doctor: string = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentStart())
    let response
    if(doctor) {
      response = await post(`payment?doctor=${doctor}`, data);
    } else {
      response = await post(`payment`, data);
    }
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusPaymentFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentFailure(errData))
      return [errData]
    }
  }
}

export const EditPaymentApi = (doctor: string = "", paymentId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentStart())
    const response = await put(`payment/${paymentId}?doctor=${doctor}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusPaymentFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentFailure(errData))
      return [errData]
    }
  }
}

export const DeletePaymentApi = (paymentId: string, doctor: string = "") => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusPaymentStart())
    const response = await remove(`payment/${paymentId}?doctor=${doctor}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusPaymentSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusPaymentFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusPaymentFailure(errData))
      return [errData]
    }
  }
}


export const clearPaymentApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusPaymentSuccess([]))
}
